module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/cliente-tipo/cliente-tipo.component.css
// module id = ./src/app/cliente-tipo/cliente-tipo.component.css
// module chunks = main